export default "__VITE_ASSET__c204a2b3__"